import { SearchOutlined } from '@ant-design/icons';
import { Col, DatePicker, Form, FormInstance } from 'antd';
import { AxiosError } from 'axios';
import { useCallback, useContext, useEffect } from 'react';
import GetVisions from '~/@core/application/useCases/rfidReports/expedition/getVisions';
import DefaultPaginated from '~/@core/domain/@shared/DefaultPaginated';
import ExpeditionDone from '~/@core/domain/model/rfidReports/ExpeditionDone';

import FormFilterDataModel, {
  MapFormToFilter
} from '~/@core/domain/ui/forms/FormFilterDataModel';
import DefaultRow from '~/components/bosons/DefaultRow';
import SearchButton from '~/components/Buttons/SearchButton';
import { globalContext } from '~/context/GlobalContext';
import useVisionStore from '~/zustand/rfidReports/expedition/vision-state';
import { SearchButtonDiv } from '../../Inventory/Dones/FormFilterInventoryDone.styled';

interface Props {
  form: FormInstance<FormFilterDataModel>;
}
export default function FormFilterExpeditionVision(props: Props) {
  const { form } = props;
  const {
    visionPagination,
    addVisions,
    handleVisionPagination,
    setIsLoadingVisions
  } = useVisionStore();

  const { handlePromiseUseCase, activeAlert } = useContext(globalContext);

  useEffect(() => {
    form.setFieldsValue({
      dtaFilter: []
    });
  }, [form]);

  const onSubmitFilter = useCallback(
    (formValues: FormFilterDataModel) => {
      const filterVision = MapFormToFilter.toFilter(formValues, {
        pageSize: visionPagination.pageSize,
        pageNumber: visionPagination.current
      });

      const getVisions = new GetVisions();
      setIsLoadingVisions();

      handlePromiseUseCase<DefaultPaginated<ExpeditionDone[]>, AxiosError>(
        getVisions.execute(filterVision),
        visionsOut => {
          addVisions(visionsOut.results);
          handleVisionPagination({
            ...visionPagination,
            total: visionsOut.totalCount
          });
          setIsLoadingVisions();
        },
        error => {
          activeAlert({
            message: JSON.stringify(
              error.response?.data
                ? error.response?.data
                : 'Houve um erro inesperado!'
            ),
            type: 'error',
            timeout: 5000
          });
          setIsLoadingVisions();
        }
      );
    },
    [
      visionPagination,
      setIsLoadingVisions,
      handlePromiseUseCase,
      addVisions,
      handleVisionPagination,
      activeAlert
    ]
  );

  return (
    <Form layout="vertical" form={form} onFinish={onSubmitFilter}>
      <DefaultRow>
        <Col lg={6}>
          <Form.Item name="dtaFilter" label="Data de Consulta: ">
            <DatePicker.RangePicker
              format="DD/MM/YYYY"
              placeholder={['Início', 'Fim']}
            />
          </Form.Item>
        </Col>
        <Col lg={3}>
          <SearchButtonDiv>
            <SearchButton
              htmlType="submit"
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => {}}
            />
          </SearchButtonDiv>
        </Col>
      </DefaultRow>
    </Form>
  );
}
